var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSettings(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 6c-1-1.2-2.3-2.1-3.8-2.7 0-1-.7-1.8-1.7-2-1.2-.2-2.5-.2-3.8 0-1 .2-1.7 1.1-1.6 2-.3.1-.6.3-.9.4-1.1.6-2.1 1.4-2.8 2.4-.9-.3-2 .1-2.4 1-.6 1.1-1 2.3-1.1 3.6-.1 1 .5 1.9 1.4 2.2.1 1.3.5 2.6 1.1 3.8.1.2.2.4.4.6-.6.8-.5 1.9.2 2.6.8.8 1.8 1.6 2.9 2.1.6.3 1.3.3 1.8 0 .3-.2.5-.4.7-.6 1.5.4 3.1.4 4.6 0 .6.8 1.6 1.1 2.5.7l.3-.1c1-.5 2-1.2 2.8-2.1.7-.7.7-1.8.1-2.6.8-1.3 1.3-2.9 1.4-4.4.1 0 .2-.1.4-.2.7-.4 1.2-1.2 1-2.1-.2-1.3-.6-2.4-1.2-3.6-.4-1-1.4-1.4-2.3-1zm-1.1 10.4c-.6.9-1.5 1.8-2.6 2.3-.4.2-.9.4-1.3.5-1.4.5-3 .4-4.4 0-1.6-.5-3-1.4-4-2.8-.2-.2-.4-.5-.5-.8-.6-1.1-.9-2.2-.9-3.4 0-1.7.5-3.3 1.5-4.6.6-.8 1.5-1.6 2.5-2.1.3-.2.7-.3 1-.5 1.6-.6 3.3-.6 4.9 0 1.4.5 2.7 1.3 3.6 2.6.2.3.5.6.7 1 .6 1.2.9 2.4.9 3.6-.1 1.5-.6 3-1.4 4.2z",
    fill: "#050505"
  })));
}

export default SvgIconSettings;